import { render, staticRenderFns } from "./VxTablePagination.vue?vue&type=template&id=54295808&scoped=true&"
import script from "./VxTablePagination.vue?vue&type=script&lang=js&"
export * from "./VxTablePagination.vue?vue&type=script&lang=js&"
import style0 from "./VxTablePagination.vue?vue&type=style&index=0&id=54295808&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54295808",
  null
  
)

export default component.exports